import React from "react";
import { useSearchParams } from "react-router-dom";

import Box from "@mui/material/Box";

import { FilterStore } from "stores";

import {
  AufbauFilter,
  AusstattungFilter,
  FarbeAussenFilter,
  FinanceFilter,
  FzartFilter,
  GetriebeFilter,
  ErstzulassungFilter,
  KilometerFilter,
  KraftstoffFilter,
  LocationFilter,
  MarkeModellGruppeFilter,
  LeistungFilter,
  TuerenFilter,
  SitzeFilter,
} from "./components/filters";

import { FilterStatus } from "./Status";

interface iFilter {
  disableMake?: boolean;
}

const Filter: React.FC<iFilter> = ({
  disableMake = false,
}): JSX.Element | null => {
  return (
    <Box
      id="carbando-page-catalog-sidefilter-root"
      sx={{
        position: "sticky",
        top: 0,
        height: "100vh",
        overflowY: "scroll",
        overflowX: "hidden",
        paddingRight: "1rem",
      }}
    >
      <FilterStatus
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 1,
          backgroundColor: "white",
          py: 1,
        }}
      />
      <FinanceFilter />
      <MarkeModellGruppeFilter disabled={disableMake} />
      <KilometerFilter />
      <ErstzulassungFilter />
      <LocationFilter />
      <FzartFilter />
      <KraftstoffFilter />
      <LeistungFilter />
      <AufbauFilter />
      <AusstattungFilter />
      <GetriebeFilter />
      <FarbeAussenFilter />
      {process.env.REACT_APP_VEHICLE_TYPE !== "krad" && <TuerenFilter />}
      {process.env.REACT_APP_VEHICLE_TYPE !== "krad" && <SitzeFilter />}
      <Parameterizer />
    </Box>
  );
};

export default Filter;

const Parameterizer = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const {
    state: { filter },
  } = React.useContext(FilterStore);

  const checkAndAdd = (which: string, filter: any, paramsMap: any): any => {
    if (filter[which] && filter[which].length > 0)
      paramsMap.set(which, filter[which]);
    return paramsMap;
  };
  const filterParameters = [
    "marke",
    "modell",
    "modell_gruppe",
    "location",
    "kraftstoff",
    "leistung",
    "aufbau",
    "fzart",
    "erstzulassung",
    "kilometer",
    "getriebe",
    "ausstattung",
    "farbe_aussen",
    "tueren",
    "sitze",
  ];

  React.useEffect(() => {
    const URLFilters = new URLSearchParams(searchParams);

    // Remove controlled parameters first so they don't persist if they are empty in the state
    filterParameters.forEach((param) => URLFilters.delete(param));
    URLFilters.delete("finance-buy");
    URLFilters.delete("finance-lease");

    filterParameters.forEach((which: string) =>
      checkAndAdd(which, filter, URLFilters),
    );

    if (filter.finance) {
      if (filter.finance.type === "buy") {
        URLFilters.set("finance-buy", filter.finance.price);
      }
      if (filter.finance.type === "lease") {
        URLFilters.set("finance-lease", filter.finance.rate);
      }
    }

    if (URLFilters.toString() !== searchParams.toString()) {
      setSearchParams(URLFilters);
    }
  }, [filter, searchParams, setSearchParams]);
  return <></>;
};
